import { fetchResource } from '@/services/fetchService.js'

class ChannelService {
  constructor() {
    this.type = ''
  }

  fetchChannels = async ({ filter }) => {
    const params = { filter }
    const channels = await fetchResource('channels', params)
    return channels
  }

  fetchChannel = async ({ id, slug }) => {
    const resource = 'channel'
    const path = id ? `${resource}/${id}` : `${resource}/slug/${slug}`
    const channel = await fetchResource(path)
    return channel
  }
}

export default ChannelService
export const channelService = new ChannelService()
